import { useCallback } from "react";
import { useClaims } from "../../../../../auth/ClaimsProvider";
import { ShiOnePermission } from "../../../../../auth/authorizationTypes";
import type { BuyAgainResponse } from "@features/ecommerce/hooks/useBuyAgainOrder";

export type OrdersCartHandoffOutcome =
  | "no-cart-view"
  | "zero-success"
  | "stayed";

export function useOrdersCartHandoff() {
  const { hasPermission } = useClaims();
  const canSaveToCart = hasPermission(ShiOnePermission.shoppingCartSave);
  const canViewCart = hasPermission(ShiOnePermission.shoppingCartView);

  const handoffBuyAgainSuccess = useCallback(
    (result: BuyAgainResponse): OrdersCartHandoffOutcome => {
      if (result.successCount === 0) {
        return "zero-success";
      }

      if (!canViewCart) {
        return "no-cart-view";
      }

      return "stayed";
    },
    [canViewCart],
  );

  return {
    canSaveToCart,
    canViewCart,
    handoffBuyAgainSuccess,
  };
}
